<template>
  <VTable
    :name="tableName"
    :items="items"
    :fields="fields"
    :checked-rows="checkedItems"
    :loading="loading"
    :on-input-search="onInputSearch"
    :on-edit-item="onEditItem"
    :on-delete-item="onDeleteItem"
    searchPlaceholder="Search for comment...."
    hide-add-button
    hover
    striped
    border
    small
    fixed
    dark
  >
    <template #footer>
      <VPagination :items-count="itemsCount" class="user-manager-card__footer-pagination" />
    </template>
  </VTable>
</template>
<script>
import {
  createCommentsStoreMixin,
  commentsStore
} from "@/mixins/commentsMixin";
import { createTableStoreMixin, tableStore } from "@/mixins/tableMixin";
import { debounce } from "@/utils/debounce";
import ModalType from "@/utils/dictionaries/modalType"

export default {
  name: "TheAllCommentsTable",

  mixins: [createCommentsStoreMixin(), createTableStoreMixin()],

  data: () => {
    return {
      loading: false,
      lastSearchTerm: null,
      searchFn: () => {}
    };
  },

  computed: {
    tableName() {
      return "allComments";
    },
    fields() {
      return [
        { key: "check", _classes: "checkbox" },
        {
          key: "username",
          label: "Username",
          _style: "min-width: 65px",
          _classes: "username"
        },
        {
          key: "show_details",
          label: "Comment",
          _style: "min-width: 35px;max-width: 50px"
        },
        { key: "likes", label: "Like", _style: "min-width: 25px" },
        { key: "inappropriate", label: "Dislike", _style: "min-width: 25px" },
        {
          key: "link",
          label: "Link",
          _style: "min-width: 25px;max-width: 62px"
        },
        { key: "action", _style: "max-width: 20px;min-width:20px" }
      ];
    },
    checkedItems() {
      return this[tableStore.getterTypes.GETTER_CHECKED_ROWS][this.tableName];
    },
    items() {
      return this[commentsStore.getterTypes.GETTER_COMMENTS];
    },
    itemsCount() {
      return this[commentsStore.getterTypes.GETTER_COMMENTS_COUNT];
    }
  },

  watch: {
    $route() {
      this.loadData();
    }
  },

  async created () {
    this[commentsStore.actionTypes.ACTION_INIT_WS]()
    this[commentsStore.actionTypes.ACTION_JOIN_TO_COMMENTS]()
    await this.loadData()

    this.searchFn = debounce.call(this, async (term) => {
      const query = {
        ...this.$route.query,
        search: term
      }

      if (!query.search && query.skip) {
        query.skip = 0
      }

      this.$router.push({
        query
      }).catch(() => {})
    }, 200)
  },

  methods: {
    getLastComments() {
      return this.items
        .map(u => ({ created_at: u.createdAt, id: u.id }));
    },
    onInputSearch(t) {
      this.searchFn(t);
    },
    onEditItem (item) {
      this.$modals.open(ModalType.CommentModal, item)
    },
    onDeleteItem(item) {
      const ids = [...this.checkedItems]
        .map(u => u.id)
        .filter((id, index, arr) => index === arr.indexOf(id));

      const lastComments = this.getLastComments().filter(u => !ids.includes(u.id));

      const deleteAction = () => {
        this[commentsStore.actionTypes.ACTION_DELETE_COMMENTS]({
          comments: ids,
          lastComments
        });

        if (ids.length === this.items.length) {
          this.$router.push({
            query: ""
          });
        }

        this[tableStore.mutationTypes.MUTATION_UNSET_CHECKED_ROWS](
          this.tableName
        )

        this.$modals.close(ModalType.ConfirmationModal)
      }

      this.$modals.open(ModalType.ConfirmationModal, {
        title: 'Deletion',
        body: `Are you sure you want to delete <strong>${ ids.length }</strong> ${ ids.length > 1 ? 'comments' : 'comment' }?`,
        buttonText: 'Delete',
        onClickButton: deleteAction
      })
    },
    async loadData() {
      this[tableStore.mutationTypes.MUTATION_UNSET_CHECKED_ROWS](
        this.tableName
      );
      this.loading = true;
      await this[commentsStore.actionTypes.ACTION_LOAD_COMMENTS]({
        take: this.$route.query.take,
        skip: this.$route.query.skip,
        search: this.$route.query.search
      });
      this.loading = false;
    }
  }
}
</script>
